import React from "react";
import { Modal, Row, Col,Statistic } from "antd";
import { useTranslation } from 'react-i18next'
import moment from "moment";
import EjeFinal from "../../img/Eje-Final.jpg"
import RuedaFinal from "../../img/Rueda-Final.jpg"
import { grades } from "../../constants";
const ArticleModal = ({ visible, handleVisible, article }) => {
  const handleOk = () => {
    handleVisible(false);
  };
  const gradeText = article && grades.find(grade => grade.value === article.grade).name;
  const { t } = useTranslation();
  return (
    article && (
      <div>
        <Modal
          title={(article.articleName ? article.articleName : t('table.header.article') )}
          visible={visible}
          onOk={handleOk}
          onCancel={handleOk}
          width="50vw"
          footer={null}
          style={{top:"10%"}}
        >
          <Row style={{marginBottom:"2%",textAlign:"center"}}>
            <Col span={24} style={{marginBottom:"5%"}}>
                <img
                  alt="Pieza"
                  style={{ width: 353, height: 221, marginleft:'40%' }}
                  src={article && article.figure === "eje" ?EjeFinal:RuedaFinal}
                />
            </Col>

            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('table.header.geometryFin')}value={article && article.geometriaFinal } suffix="" />
            </Col>
            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('labels.article_date')}value={article && moment(article.date).format("DD/MM/YYYY HH:mm:ss")} suffix="" />
            </Col> 
            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('labels.steel_grade')} value={gradeText} suffix="" precision={0} />
            </Col>

            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('labels.LimiteElastico')} value={article && article.EspMecanicas.limiteElastico} suffix="MPa" precision={0} />
            </Col>
            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('labels.ResAtraccion')} value={article && article.EspMecanicas.resistenciaAtraccion} suffix="MPa" precision={0} />
            </Col>
            <Col span={6} style={{marginLeft:"5%",marginBottom:"5%"}}>
                <Statistic title={t('labels.ElonRotura')} value={article && article.EspMecanicas.ElonRotura} suffix="%" precision={0} />
            </Col>

            <Col span={6} style={{marginLeft:"5%"}}>
                <Statistic title={t('labels.RedArea')} value={article && article.EspMecanicas.RedArea} suffix="%" precision={0} />
            </Col>
            <Col span={6} style={{marginLeft:"5%"}}>
                <Statistic title={t('labels.hardness')} value={article && article.EspMecanicas.Dureza} suffix="HRC" precision={0} />
            </Col>
            <Col span={6} style={{marginLeft:"5%"}}>
                <Statistic title={t('labels.EneImpacto')} value={article && article.EspMecanicas.EnergiaImp.Valor+"J - "+article.EspMecanicas.EnergiaImp.temp+"ºC"} suffix="" precision={0} />
            </Col>

          </Row >
        </Modal>
      </div>
    )
  );
};

export default ArticleModal;